import { compose } from 'ramda';

import connect from 'app/libs/connect';
import wrapIn from 'app/enhancers/wrapIn';
import { appStoreNavigated } from 'app/features/success/actions';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { UI } from 'app/features/success/offlineViewingBlock/components/OfflineViewingBlock';

const OfflineViewing = compose(
  connect(null, { appStoreNavigated }),
  wrapIn(BlockWrapper),
)(UI);

export default OfflineViewing;
